export default "__VITE_ASSET__CBd8WMoa__"